import { IconButton, Icons, useDynamicGridContext } from '@cast/design-system';

export const InventoryWorkloadsDashboardCustomizeButton = () => {
  const { isCustomizing, setIsCustomizing } = useDynamicGridContext();
  return (
    <IconButton
      variant="secondary"
      size="sm"
      disabled={isCustomizing}
      onClick={() => setIsCustomizing(true)}
      testId="workloads-dashboard-customize"
      aria-label="Customize dashboard"
    >
      <Icons.Sliders />
    </IconButton>
  );
};
